import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import errorCode from '@/utils/errorCode'
import router from '@/router'
import qs from 'qs'
import { tansParams } from './util'

let baseURL = (process.env.NODE_ENV == 'development' ? '/api':process.env.VUE_APP_BASE_API )  
// 是否显示重新登录
export let isRelogin = { show: false };
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseURL,
  // 超时
  timeout: 100000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false

  if (sessionStorage.getItem('TOKEN') && !isToken) {
    config.headers['token'] =  sessionStorage.getItem('TOKEN') // 让每个请求携带自定义token 请根据实际情况自行修改
  }
   // get请求映射params参数
   if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (config.type === 'form') {
    let data = qs.stringify(config.data)
    config.data = data
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
  }else if(config.type === 'upload'){
    config.headers['Content-Type'] = 'multipart/form-data; charset=UTF-8'
  } else {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // const res = response.data

  // 未设置状态码则默认成功状态
  const code = res.status || 200;
  // // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  
  if (code === 401) {
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  }else if (code === 500) {
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))
  }  else {
    if (res.data.code !== 200) {
      Message({
        message: res.data.msg,
        type: 'error'
      })
      if(res.data.code === 100005){
        sessionStorage.removeItem('TOKEN')
        sessionStorage.removeItem('USER')
        sessionStorage.removeItem('MENU')
        sessionStorage.clear()
        setTimeout(()=>{
          router.push('/login')
        },500)
      }
      
    }else {
      return res.data
    }

  }
},
  error => {
    console.log('err' + error)
    let { message } = error;
   
    if (message == "Network Error") {
      message = "连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      if (message.substr(message.length - 3) == 401) {
        message ='无效的会话，或者会话已过期，请重新登录。'
        MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
        ).then(() => {
          isRelogin.show = false;
          sessionStorage.removeItem('TOKEN')
          sessionStorage.removeItem('USER')
          router.push('/login')
        }).catch(() => {
          isRelogin.show = false;
        });
         
      }else{
        message = "系统接口" + message.substr(message.length - 3) + "异常";
      }
      
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
